import { whenConsented } from "../helper/whenConsented";

export const PrefetchMixin =
{
	props: {
		whenConsented: {
			type: String,
			default: ""
		},
		idleTimeout: {
			type: Number,
			default: 2000
		},
		waitForConsent: {
			type: Boolean,
			default: true
		},
		waitForIdle: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			prefetch: false,
			isIdle: false,
			ignoreConsent: false,
			cleanupHandlers: []
		};
	},

	mounted() {
		if (typeof window !== "undefined" && App.urls.privacyPolicy === window.location.pathname) {
			this.ignoreConsent = true;
			this.prefetch = true;
			this.emitEvent();
		} else {
			whenConsented(
				this.whenConsented,
				() => {
					this.prefetch = true;
					this.emitEvent();
				},
				() => {}
			);
		}

		if (!(`requestIdleCallback` in window) || !(`requestAnimationFrame` in window)) {
			this.triggerIdle();
		} else {
			// @ts-ignore
			const id = requestIdleCallback(
				() => {
					requestAnimationFrame(this.triggerIdle);
				},
				{ timeout: this.idleTimeout }
			);
			// @ts-ignore

			this.cleanupHandlers.push(() => cancelIdleCallback(id));
		}
	},

	beforeDestroy() {
		this.cleanup();
	},

	methods: {
		triggerIdle() {
			this.isIdle = true;
			this.emitEvent();
		},
		emitEvent() {
			if (
				(this.ignoreConsent || !this.waitForConsent || (this.waitForConsent && this.prefetch)) &&
				(!this.waitForIdle || (this.waitForIdle && this.isIdle))
			) {
				vueEventHub.$emit("prefetch");
				this.$emit("prefetch");
				this.cleanup();
			}
		},
		cleanup() {
			this.cleanupHandlers.forEach(handler => handler());
		}
	}
};
